import React, { useEffect, useState } from 'react';
import { FieldValues, Path } from 'react-hook-form';
import RadioList, { FilterListItem } from '../../../components/ModernFilters/RadioList';
import { cameraService } from '../../../services/central-api/cameras';

function VideoAnalysisRequesterList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    const [items, setItems] = useState<FilterListItem<number | null>[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getUsers() {
        try {
            const users = await cameraService.getUsers();
            setItems(users.map(user => ({
                label: user.warName || user.name,
                value: user.id,
            })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getUsers();
    }, []);

    return <RadioList name={name} items={items} clearValue={null} isLoading={isLoading} />;
}

VideoAnalysisRequesterList.getCount = RadioList.getCount;

export default VideoAnalysisRequesterList;
